const actions = {
  SET_STATE: 'languages/SET_STATE',
  FETCH_ALL: 'languages/FETCH_ALL'
};

export default actions
